// extracted by mini-css-extract-plugin
export default {"dialog":"JsonSchemaDialog-module__dialog--M3_kr"};